import _ from 'lodash';

import { BusinessHoursWeekdayMap, ExtendedPublicHours } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { PublicHours } = protos;

export function createPublicHours(publicHours: ExtendedPublicHours): ApiAction {
  const request = PublicHours.fromObject(_.omit(publicHours, 'state'));
  return {
    TockApi: {
      postProto: '/business/public/hours',
      type: AppConstants.PUBLIC_HOURS_CREATE,
      request,
      toast: 'Public hours created',
    },
  };
}

export function updatePublicHours(publicHoursChange: ExtendedPublicHours): ApiAction {
  const request = PublicHours.fromObject(_.omit(publicHoursChange, 'state'));
  return {
    TockApi: {
      putProto: '/business/public/hours',
      type: AppConstants.PUBLIC_HOURS_UPDATE,
      request,
      toast: 'Public hours updated',
    },
  };
}

export function deletePublicHours(publicHours: ExtendedPublicHours): ApiAction {
  return {
    TockApi: {
      deleteProto: `/business/public/hours/${publicHours.id}`,
      type: AppConstants.PUBLIC_HOURS_DELETE,
      context: { deletedPublicHours: publicHours },
    },
  };
}

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/business/public/hours',
      type: AppConstants.PUBLIC_HOURS_FETCH_ALL,
    },
  };
}

/**
 * Takes servicesByWeekday with which to initialize the public hours.
 * This is useful for bootstrapping public hours if you have services configured,
 * since the form will default to the service hours and then any save will
 * fill in the public hours.
 * @param servicesByWeekday A map of servicesByWeekday with which to initialize the reducer
 */
export function initializeLocalPublicHoursFromServices(
  servicesByWeekday: BusinessHoursWeekdayMap
): BaseTockAction {
  return {
    type: AppConstants.PUBLIC_HOURS_INITIALIZE_FROM_SERVICES,
    payload: servicesByWeekday,
  };
}

export function createLocalPublicHours(weekday: Weekday): BaseTockAction {
  return {
    type: AppConstants.PUBLIC_HOURS_CREATE,
    payload: weekday,
  };
}

export function updateLocalPublicHours(
  publicHoursChange: ExtendedPublicHours,
  index: number
): BaseTockAction {
  return {
    type: AppConstants.PUBLIC_HOURS_UPDATE,
    payload: {
      publicHoursChange,
      index,
    },
  };
}

export function deleteLocalPublicHours(
  publicHours: ExtendedPublicHours,
  index: number
): BaseTockAction {
  return {
    type: AppConstants.PUBLIC_HOURS_DELETE,
    payload: {
      publicHours,
      index,
    },
  };
}
